import {ReferencePoint, RegionConfig} from '../../../types'

const GH12: ReferencePoint = {
  geo: {latitude: 5.556, longitude: -0.196},
  svg: {x: 185, y: 853}
}

const EG11: ReferencePoint = {
  geo: {latitude: 30.0435, longitude: 31.2353},
  svg: {x: 370, y: 705}
}

const TZ10: ReferencePoint = {
  geo: {latitude: -6.66251, longitude: 39.16774},
  svg: {x: 412, y: 920}
}

const KZ20: ReferencePoint = {
  geo: {latitude: 44.17, longitude: 52.07},
  svg: {x: 490, y: 600}
}

export const AMWA_CONFIG: RegionConfig = {
  triangles: [
    {
      name: 'Africa (GH12-EG11-TZ10)',
      points: [GH12, EG11, TZ10]
    },
    {
      name: 'East (EG11-TZ10-KZ20)',
      points: [EG11, TZ10, KZ20]
    }
  ]
}
